import $ from 'jquery';
import _ from 'underscore';
import Cache from 'root/cache';
import Util from 'root/module/util';
import View from 'view/base';
import {loadFeedbackCommentTemplates, saveFeedbackCommentTemplate} from 'service/feedback';
import Modals from 'root/modals';
import Form from 'root/module/form';
import Constants from 'root/constants';
import UI from 'root/ui';
import {loadSurveys} from 'root/service/survey';
import Collection_Survey from 'collection/survey';

var Comment_Template_Edit = View.extend({
    className: 'comment-template-edit-box',

    selected_template_id: null,
    search_value: '',

    events: {
        'click .feedback-comment-template-item': 'onSelect',
        'submit form'                          : 'onSave',
        'click .edit-delete'                   : 'onDelete',
        'change input[name="access_type"]'     : 'onTemplateChange',
        'input input[name="name"]'             : 'onTemplateChange',
        'input textarea[name="content"]'       : 'onTemplateChange',
        'click .nav-close'                     : 'closeView',
        'click .wildcard-text'                 : 'onClickWildcardText',
        'input input[name="search"]'           : 'onSearch',
        'click .dropdown-survey li'            : 'onSelectSurvey',
        'click .create-new-template'           : 'onCreate',
        'click .clear-search'                  : 'onClearSearch',
        'click .reply-template-preview'        : 'onPreview'
    },

    dom_handlers: {
        onSelect: function(e) {
            var target = $(e.currentTarget);
            var id = target.data('id');

            this.selectTemplate(id);
            this.renderForm();

            this.$el.find('form input[name="name"]').focus();
        },

        onCreate: function(e) {
            e.preventDefault();
            this.newTemplate();
        },

        onSave: function(e) {
            var form_data = Form.getData(this.$el.find('form'));
            // disable the save button
            this.$el.find('.save-template').prop('disabled', true);
            saveFeedbackCommentTemplate((response) => {
                // update the selected template id
                this.selectTemplate(response.id);
                // clean up the new template data
                this.new_template_data = null;
                // show message
                UI.success('Template saved successfully');
                this.search(this.search_value);
            }, this.selected_template_id, form_data.access_type, form_data.name, form_data.content);
        },

        onDelete: function(e) {
            var target = $(e.currentTarget);
            var template_id = target.closest('.feedback-comment-template-item').data('id');
            Modals.openFeedbackCommentDeleteModal(template_id, () => {
                // update this.selected_template_id to first template
                var first_template = this.getFirstTemplate();

                if (first_template) {
                    this.selectTemplate(first_template.id);
                    this.renderTemplateList();
                    this.renderForm();
                } else {
                    this.selected_template_id = null;
                    this.renderEmptyForm();
                }

                // show message
                UI.success('Template deleted successfully');
            });
        },

        onTemplateChange: function(e) {
            if (this.canEditTemplate()) {
                this.handleTemplateChange();
            }
        },

        closeView: function() {
            this.remove();
        },

        onClickWildcardText: function(e) {
            var target = $(e.currentTarget);
            var text = target.text();
            var textarea = this.$el.find('textarea[name="content"]');
            var cursor_position = textarea.prop('selectionStart');
            var content = textarea.val();
            var new_content = content.slice(0, cursor_position) + text + content.slice(cursor_position);

            textarea.val(new_content);
            textarea.focus();
            textarea[0].setSelectionRange(cursor_position + text.length, cursor_position + text.length);

            this.handleTemplateChange();
        },

        onSearch: function(e) {
            var search_value = $(e.currentTarget).val().trim().toLowerCase();

            this.search(search_value);
        },
        onClearSearch: function(e) {
            e.preventDefault();
            // clear search box
            this.$el.find('input[name="search"]').val('');
            this.search('');
        },
        onSelectSurvey: function(e) {
            var survey_key = $(e.currentTarget).data('id');

            var textarea = this.$el.find('textarea[name="content"]');
            var segments = textarea.val().split('');

            var start = textarea.get(0).selectionStart;
            var end = textarea.get(0).selectionEnd;

            var survey = this.survey.findWhere({survey_key: survey_key});
            var survey_link = survey.getShareUrl();

            segments.splice(start, end - start, survey_link);

            var value = segments.join('');

            textarea.val(value);

            this.handleTemplateChange();
        },
        onPreview: function(e) {
            e.preventDefault();

            var form_data = Form.getData(this.$el.find('form'));
            Modals.previewReplyTemplate(form_data?.content || '');
        }
    },

    event_handlers: {
        onTemplateDataChange: function() {
            this.feedback_comment_template = Cache.feedback_comment_template.deepClone();
            this.render();
            // set the default selected template
            if (this.selected_template_id) {
                this.selectTemplate(this.selected_template_id);
            } else if (this.feedback_comment_template.length) {
                var selected_template = this.getFirstTemplate();

                if (selected_template) {
                    this.selectTemplate(selected_template.id);
                }

                this.selected_template_id = selected_template ? selected_template.id: null;
            }
        },
    },

    newTemplate: function() {
        this.selected_template_id = null;
        // render the template
        this.renderTemplateList();
        this.renderForm();
        this.renderCreateNewForm();

        this.$el.find('form input[name="name"]').focus();
    },

    search: function(search_value) {
        this.search_value = search_value;
        var filtered_template = [];
        // handle the search part
        filtered_template = Cache.feedback_comment_template.filter((model) => {
            return model.get('name').toLowerCase().indexOf(this.search_value) !== -1;
        });

        if (filtered_template.length > 0) {
            // if selected template is not in the filtered template, select the first one
            if (!filtered_template.some(item => item.id === this.selected_template_id)) {
                this.selectTemplate(filtered_template[0].id);
            }
            this.renderForm();
        } else {
            this.selected_template_id = null;
            this.renderEmptyForm();
        }

        this.renderTemplateList();
    },

    initialize: function() {
        this.listenTo(Cache.feedback_comment_template, 'reset', this.event_handlers.onTemplateDataChange);
        this.listenTo(Cache.feedback_comment_template, 'add', this.event_handlers.onTemplateDataChange);
        this.listenTo(Cache.feedback_comment_template, 'change', this.event_handlers.onTemplateDataChange);
        this.listenTo(Cache.feedback_comment_template, 'remove', this.event_handlers.onTemplateDataChange);

        this.survey = new Collection_Survey();
        this.listenTo(this.survey, 'reset', this.renderSurveyDropdown);
        this.feedback_comment_template = Cache.feedback_comment_template.deepClone();

        const first_template = this.getFirstTemplate();
        this.selected_template_id = first_template ? first_template.id : null;
    },

    getFirstTemplate: function() {
        var filtered_template = [];

        // handle the search part
        filtered_template = this.feedback_comment_template.filter((model) => {
            return model.get('name').toLowerCase().indexOf(this.search_value) !== -1;
        });

        if (filtered_template.length > 0) {
            return filtered_template[0];
        }

        return null;
    },

    handleTemplateChange: function() {
        var form_data = Form.getData(this.$el.find('form'));

        this.$el.find('.save-template').prop('disabled', this.isChanged() && this.isFormValidToSave() ? false : true);

        if (!this.selected_template_id) {
            this.new_template_data = form_data;
        } else {
            var selected_template = this.feedback_comment_template.get(this.selected_template_id);
            selected_template.set({
                ...form_data, access_type: form_data.access_type.toString()
            });
        }
    },

    isFormValidToSave: function() {
        var form_data = Form.getData(this.$el.find('form'));

        return form_data.name?.trim() && form_data.content?.trim();
    },

    isChanged: function() {
        // Get the original template
        var selected_template = Cache.feedback_comment_template.get(this.selected_template_id);
        if (!selected_template) {
            return true;
        }

        var form_data = Form.getData(this.$el.find('form'));

        return selected_template.get('access_type') !== form_data.access_type?.toString()
        || selected_template.get('name') !== form_data.name
        || selected_template.get('content') !== form_data.content;
    },

    canEditTemplate: function() {
        var selected_template = Cache.feedback_comment_template.get(this.selected_template_id);
        // set created_by to -1 if its new template
        var created_by = selected_template ? selected_template.get('created_by'): -1;
        var user_id = Cache.real_user_id;
        var is_my_template = created_by === user_id && created_by > 0;

        return is_my_template || Cache.app.isAdmin() || created_by === -1;
    },

    canEditAccess: function() {
        // only yourself can edit the access type
        var selected_template = Cache.feedback_comment_template.get(this.selected_template_id);
        var created_by = selected_template ? selected_template.get('created_by'): -1;
        var user_id = Cache.real_user_id;
        var is_my_template = created_by === user_id && created_by > 0;

        // only yourself can edit the access type
        // or admin can edit the access type of system default template
        // or new template
        return is_my_template || (Cache.app.isAdmin() && created_by === 0) || created_by === -1;
    },

    selectTemplate: function(id) {
        if (this.selected_template_id === id) {
            return;
        }

        this.selected_template_id = id;

        // render the template
        this.renderTemplateList();

        // change save template text to save template
        this.$el.find('.save-template').text('Save template');
        this.$el.find('.save-template').show();
        this.$el.find('.save-template').prop('disabled', this.isChanged() && this.isFormValidToSave() ? false : true);
    },

    renderTemplateList: function() {
        var template = '';
        var filtered_template = [];
        // handle the search part
        filtered_template = Cache.feedback_comment_template.filter((model) => {
            return model.get('name').toLowerCase().indexOf(this.search_value) !== -1;
        });

        if (filtered_template.length === 0) {
            // show no template message
            template = '<div class="empty-state flex-start italic">No templates found</div>';
        } else {
            filtered_template.forEach((model) => {
                var access_type_raw = model.get('access_type').split(',');
                var access_type = access_type_raw.map(item => parseInt(item, 10));
                // check if this access type include 1
                var access_tags = '';
                if (access_type.includes(Constants.FEEDBACK_COMMENT_TEMPLATE_ACCESS_TYPE_ALL)) {
                    access_tags += '<span class="badge-primary-invert font-weight-medium">Everyone</span>';
                } else {
                    access_tags += '<span class="badge-primary-invert font-weight-medium">Myself</span>';
                }

                var is_system_default = model.get('created_by') === 0;
                var created_by = Cache.user.get(model.get('created_by'));
                var created_by_name = created_by ? created_by.escape('name') : 'Deleted User';

                template += '<div class="feedback-comment-template-item ' + (model.id === this.selected_template_id ? 'selected' : '') + '" data-id="' + model.id + '">' +
                    '<div class="template-name margin-bottom-8">' + model.escape('name') + '</div>' +
                    '<div class="template-content ' + (access_tags ? 'margin-bottom-8' : '') + '">' + model.escape('content') + '</div>' +
                    '<div>' + access_tags + '</div>' +
                    '<div class="action-btns">' +
                        (
                            (model.get('created_by') === Cache.real_user_id || Cache.app.isAdmin()) ?
                            '<button type="button" class="edit-delete tertiary small square round stop-propagation tooltip"><i class="fa-solid fa-trash"></i></button>' : ''
                        ) +
                    '</div>' +
                    '<div class="creator">' +
                        (is_system_default ? '' :
                            created_by ?
                            '<img class="user-24 tooltip" data-title="' + created_by_name + '" src="' + created_by.getAvatar(24) + '">' :
                            '<img class="user-24 tooltip" data-title="' + created_by_name + '" src="/image/profile.png">') +
                    '</div>' +
                '</div>';
            });
        }

        this.$el.find('.feedback-comment-template-list').html(template);
    },

    renderEmptyForm: function() {
        var content =
        '<div class="icon"><i class="fad fa-file-search"></i></div>' +
        '<h1>No templates found</h1>' +
        '<p class="text-info"></p>' +
        '<p><a href="#" class="clear-search primary">Clear search</a></p>';

        if (Cache.feedback_comment_template.length === 0) {
            content =
            '<div class="icon"><i class="fad fa-file-search"></i></div>' +
            '<h1>No templates found</h1>' +
            '<p class="text-info"></p>' +
            '<p><a href="#" class="create-new-template primary">Create new template</a></p>';
        }

        this.$el.find('.search-result-empty').html(content);
        this.$el.find('.save-template').hide();

        this.$el.find('form').hide();
        // hide empty form
        this.$el.find('.search-result-container').show();
    },

    renderCreateNewForm: function() {
        // change the save template to Create new template
        // enable the save button
        this.$el.find('.save-template').text('Create new template');

        // show the save button
        this.$el.find('.save-template').show();
        this.$el.find('.save-template').prop('disabled', true);
    },

    renderSurveyDropdown: function() {
        var survey_options = '';
        this.survey.sortSurveyByStatus().forEach((survey) => {
            const project_name = Cache.project.get(survey.get('project_id')).get('name');
            const status = survey.getStatus();
            const status_text = Util.cap(survey.getStatus())
            survey_options +=
            '<li data-id="' + survey.get('survey_key') + '">' +
                '<span class="status-indicator tooltip" data-status="' + status + '" data-title="' + status_text + '"></span>' +
                Util.htmlEntities(project_name) +
            '</li>';
        });

        if (!survey_options) {
            survey_options = '<li class="disabled">No surveys found</li>';
        }

        var html =
        '<div class="button-dropdown button-dropdown-large" data-append="true">' +
            '<button type="button" class="wildcard-text-survey text-primary text-small tooltip cursor-pointer">' +
                '%%survey_link%%' +
            '</button>' +
            '<div>' +
                '<ul class="dropdown dropdown-survey" data-val="">' + survey_options + '</ul>' +
            '</div>' +
        '</div>';

        this.$el.find('.survey-dropdown-list').html(html);
    },

    renderForm: function() {
        // when there is no template, show the empty form
        const uid = _.uniqueId(this.cid);

        var content =
        '<div class="row">' +
            '<div class="field-label">Who can access?</div>' +
            '<input type="radio" id="access_type_general_' + uid + '" name="access_type" required value="' + Constants.FEEDBACK_COMMENT_TEMPLATE_ACCESS_TYPE_ALL + '">' +
            '<label for="access_type_general_' + uid + '">Everyone</label>' +
            '<input type="radio" id="access_type_myself_' + uid + '" name="access_type" required value="' + Constants.FEEDBACK_COMMENT_TEMPLATE_ACCESS_TYPE_MYSELF + '">' +
            '<label for="access_type_myself_' + uid + '">Myself only</label>' +
        '</div>' +
        '<div class="row">' +
            '<div class="field-label">Template name</div>' +
            '<input type="text" class="solid medium" name="name" maxlength="50" placeholder="Give your template a name" required>' +
            '<div class="maxlength-help"></div>' +
        '</div>' +
        '<div class="row">' +
            '<div class="field-label">Template content</div>' +
            '<textarea class="solid compact" name="content" placeholder="Add a message" rows="10" required></textarea>' +
        '</div>' +
        '<div class="preview-bar margin-bottom-12">' +
            '<div class="wildcards">' +
                '<span class="wildcard-text text-primary text-small tooltip cursor-pointer margin-right-12" data-title="Placeholder: Reporter name">%%reporter_name%%</span>' +
                '<span class="wildcard-text text-primary text-small tooltip cursor-pointer margin-right-12" data-title="Placeholder: User name">%%user_name%%</span>' +
                '<span class="wildcard-text text-primary text-small tooltip cursor-pointer margin-right-12" data-title="Placeholder: Feedback link">%%feedback_link%%</span>' +
                '<span class="survey-dropdown-list margin-right-12"></span>' +
            '</div>' +
            '<a href="#" class="reply-template-preview float-right text-medium text-primary"><i class="fa-solid fa-eye margin-right-4"></i>Preview</a>' +
        '</div>' +
        '<div class="notice-text banner-info" style="display: none;">You can not edit this template</div>';

        this.$el.find('.form-container').html(content);
        // show form
        this.$el.find('form').show();
        // hide empty form
        this.$el.find('.search-result-container').hide();

        var selected_template = this.feedback_comment_template.get(this.selected_template_id);

        if (selected_template) {
            Form.setData(this.$el.find('form'), {
                access_type: selected_template.get('access_type'),
                name: selected_template.get('name'),
                content: selected_template.get('content')
            });
        } else {
            if (this.new_template_data) {
                // prepopulate the form with the unsaved data
                var unsaved_data = this.new_template_data;

                Form.setData(this.$el.find('form'), {
                    access_type: unsaved_data.access_type || Constants.FEEDBACK_COMMENT_TEMPLATE_ACCESS_TYPE_ALL,
                    name: unsaved_data.name || '',
                    content: unsaved_data.content || '',
                });
            } else {
                Form.setData(this.$el.find('form'), {
                    access_type: Constants.FEEDBACK_COMMENT_TEMPLATE_ACCESS_TYPE_ALL,
                    name: '',
                    content: '',
                });
            }
        }

        if (this.canEditTemplate()) {
            this.$el.find('form input, form textarea').prop('readonly', false);
            // disable radio button
            this.$el.find('form input[type="radio"]').prop('disabled', this.canEditAccess() ? false : true);
            // disabled save button
            this.$el.find('.wildcards').show();
            this.$el.find('.save-template').prop('disabled', this.isChanged() && this.isFormValidToSave() ? false : true);
            this.$el.find('.notice-text').hide();
        } else {
            this.$el.find('form input, form textarea').prop('readonly', true);
            this.$el.find('form input[type="radio"]').prop('disabled', true);
            // disabled save button
            this.$el.find('.save-template').prop('disabled', true);
            this.$el.find('.wildcards').hide();
            this.$el.find('.notice-text').show();
        }

        this.renderSurveyDropdown();
    },

    render: function() {
        var content = Cache.feedback_comment_template.isLoaded() ?
        '<div class="feedback-comment-template-edit">' +
            '<div class="feedback-comment-selector">' +
                '<div class="search-box-container">' +
                    '<input type="text" class="solid compact" placeholder="Search templates..." name="search" value="' + Util.htmlEntities(this.search_value) + '">' +
                '</div>' +
                '<div class="feedback-comment-template-list">' +
                '</div>' +
            '</div>' +
            '<div class="feedback-comment-template-form">' +
                '<form class="form-fluid">' +
                    '<div class="form-container">' +
                    '</div>' +
                    '<div class="flex-end">' +
                        '<a href="https://support.userback.io/en/articles/10529712-reply-templates" class="primary font-weight-medium margin-right-16" target="help" rel="noopener">Learn more <i class="fa-solid fa-square-arrow-up-right tooltip" data-title="Learn more"></i></a>' +
                        '<button type="submit" class="primary medium min inline save-template" disabled>Save template</button>' +
                    '</div>' +
                '</form>' +
                '<div class="search-result-container">' +
                    '<div class="search-result-empty active"></div>' +
                '</div>' +
            '</div>' +
        '</div>' :
        (
            '<div class="loader-placeholder margin-bottom-8 margin-top-16"></div>' +
            '<div class="loader-placeholder margin-bottom-8"></div>' +
            '<div class="loader-placeholder"></div>'
        );

        this.$el.html(content);

        // load the data from the server if the cache.feedback_comment_template is empty
        if (!Cache.feedback_comment_template.isLoaded()) {
            loadFeedbackCommentTemplates();
        }

        // load the survey data
        if (!this.survey.isLoaded()) {
            this.survey.markAsLoaded();
            loadSurveys((response) => {
                this.survey.reset(response);
            });
        }
        this.renderTemplateList();
        this.renderForm();

        if (!this.selected_template_id && Cache.feedback_comment_template.length === 0) {
            this.renderEmptyForm();
        }

        return this;
    }
});

export default Comment_Template_Edit;
